<ng-template #multiEditTileDropdown>
  <div class="custom-popover-body p-1">
    <ng-content></ng-content>
    @if (showAddButton()) {
      <div class="text-center">
        <i
          (mouseenter)="multiEditAddHover = true"
          (mouseleave)="multiEditAddHover = false"
          data-automation="add-deskphone-button"
          class="add-deskphone-button fa fa-plus-circle fa-2x animate__animated animate__rubberBand animate__fast clickable-cursor"
          (click)="onMultiEditAddClicked()"
          [ngClass]="{ 'animate__animated animate__rubberBand animate__fast text-primary': multiEditAddHover }"
        ></i>
      </div>
    }
  </div>
</ng-template>

<div
  class="tile tile-info"
  data-automation="ziro-multi-tile"
  [ngbPopover]="multiEditTileDropdown"
  [disablePopover]="!isEnabled()"
  [ngbTooltip]="tooltip() | translate"
  [popoverClass]="'overflow-visible'"
  [autoClose]="'outside'"
  placement="bottom"
  (mouseenter)="isHoverTile = true"
  (mouseleave)="isHoverTile = false"
>
  <div class="tile-description" [ngClass]="{ muted: !isEnabled() }">
    <div class="text-center">
      <p [ngClass]="'svg-icon-class'">
        <i [attr.data-automation]="icon()" [ngClass]="icon()" [ngStyle]="{ 'font-size': '40px' }"></i>
      </p>
      <strong data-automation="service-tile-name" class="d-block">
        {{ serviceName() | translate }}
      </strong>
      @if (description()) {
        <div class="badge bg-light text-dark">
          {{ description() | translate }}
        </div>
      }
      <div>
        @if (isHoverTile && isEnabled()) {
          <i class="fa fa-chevron-down fa-2x"></i>
        }
      </div>
    </div>
  </div>
</div>
